import EmployeeService from '../../services/employee.service';

const addEmployee = async (employeeData) => {
    try {
        return await EmployeeService.create(employeeData);
    } catch (error) {
        console.error('Error adding employee:', error.response ? error.response.data : error.message);
        // Re-throw the error so the form can handle it
        throw error;
    }
};

export default addEmployee;
